import moment from 'moment';

export default {
	date: moment().format('YYYY-MM-DD'),
	agenda: {
		replacementItens: []
	},
	completionStatus: {
		eventualMedicine: true,
		nap: true,
		evacuation: true,
		additionalMeal: true
	}
};



// WEBPACK FOOTER //
// ./sources/app/agenda/state.js